package one.healthium.health_log.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import one.healthium.health_log.ui.HealthLogScreen

@Composable
fun HealthLogContent(component: HealthLogComponent) {
    CompositionLocalProvider(LocalViewModelStoreOwner provides component) {
        HealthLogScreen(component, component.taskId)
    }
}